import { render, staticRenderFns } from "./RetailerFilters.vue?vue&type=template&id=ed0bb25a&"
import script from "./RetailerFilters.vue?vue&type=script&lang=js&"
export * from "./RetailerFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports